import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InternalParticipant } from '@/types/api';
import AddAttendeeButton from '@/components/Record/ShareButton/useShareModal/AddButton';
import { ToggleMoreButton } from '@/components/Record/ShareButton/useShareModal/AddButton/styles';
import { imgUrlChk } from '@/utils/function';
import ImageWithErrorHandling from '@/components/ImageWithErrorHandling';

/** 접힌 상태에서 기본으로 노출하는 추천 인원 수 */
const COLLAPSED_COUNT = 5;

interface RecommendedShareListProps {
  recommendedList: InternalParticipant[];
  onClickRecommended: (participant: InternalParticipant) => void;
}

const RecommendedShareList: React.FC<RecommendedShareListProps> = ({
  recommendedList,
  onClickRecommended,
}) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  if (recommendedList.length === 0) {
    return null;
  }

  const hiddenCount = recommendedList.length - COLLAPSED_COUNT;
  const hasMore = hiddenCount > 0;
  const visibleList =
    isExpanded || !hasMore
      ? recommendedList
      : recommendedList.slice(0, COLLAPSED_COUNT);

  return (
    <>
      {visibleList.map((participant) => (
        <AddAttendeeButton
          key={participant.passportId}
          onClick={() => onClickRecommended(participant)}
        >
          <ImageWithErrorHandling
            style={{ borderRadius: '50%', objectFit: 'cover' }}
            width={20}
            height={20}
            src={imgUrlChk(participant.profileImageUrl)}
            alt={`${participant.passportId}-profile`}
            errorImage={'/images/dummy/default-profile.svg'}
          />
          <span>
            {participant.name} {participant.positionName}
          </span>
        </AddAttendeeButton>
      ))}
      {hasMore && (
        <ToggleMoreButton
          onClick={() => setIsExpanded((prev) => !prev)}
          aria-expanded={isExpanded}
        >
          {isExpanded
            ? t('접기')
            : t('{{count}}명 더보기', { count: hiddenCount })}
        </ToggleMoreButton>
      )}
    </>
  );
};

export default RecommendedShareList;
